// src/components/seo/structuredData.js
import { SEOData } from "./seoData";

// Base schema class
class Schema {
  toJson() {
    return {};
  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }
}

// WebsiteData
export class WebsiteData extends Schema {
  constructor({ name = SEOData.siteTitle, url = SEOData.siteUrl, logo = SEOData.ogImage, language } = {}) {
    super();
    this.name = name;
    this.url = url;
    this.logo = logo;
    this.language = language;
  }

  toJson() {
    const data = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: this.name,
      url: this.url,
      inLanguage: this.language,
      publisher: {
        "@type": "Organization",
        name: this.name,
        logo: { "@type": "ImageObject", url: this.logo },
      },
    };
    Object.keys(data).forEach(k => data[k] === undefined && delete data[k]);
    return data;
  }
}

// PropertyData
export class PropertyData extends Schema {
  constructor({
    name,
    description,
    url,
    images = [SEOData.ogImage],
    addressLocality = "Baia Mare",
    addressRegion = "Maramures",
    addressCountry = "RO",
    ratingValue = 5,
    ratingCount = 10,
    price = 200,
    currency = "RON",
  } = {}) {
    super();
    this.name = name;
    this.description = description || SEOData.siteDescription;
    this.url = url;
    this.images = images;
    this.addressLocality = addressLocality;
    this.addressRegion = addressRegion;
    this.addressCountry = addressCountry;
    this.ratingValue = ratingValue;
    this.ratingCount = ratingCount;
    this.price = price;
    this.currency = currency;
  }

  toJson() {
    return {
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      name: this.name,
      description: this.description,
      url: this.url,
      image: this.images,
      address: {
        "@type": "PostalAddress",
        addressLocality: this.addressLocality,
        addressRegion: this.addressRegion,
        addressCountry: this.addressCountry,
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: this.ratingValue,
        reviewCount: this.ratingCount,
      },
      priceRange: `${this.currency} ${this.price}`,
    };
  }
}

// ArticleData
export class ArticleData extends Schema {
  constructor({ headline, author = SEOData.siteAuthor, datePublished, dateModified, image = SEOData.ogImage, url } = {}) {
    super();
    this.headline = headline;
    this.author = author;
    this.datePublished = datePublished;
    this.dateModified = dateModified;
    this.image = image;
    this.url = url;
  }

  toJson() {
    return {
      "@context": "https://schema.org",
      "@type": "Article",
      headline: this.headline,
      author: { "@type": "Person", name: this.author },
      datePublished: this.datePublished,
      dateModified: this.dateModified,
      image: this.image,
      mainEntityOfPage: { "@type": "WebPage", url: this.url },
    };
  }
}

// BreadcrumbsData
export class BreadcrumbsData extends Schema {
  constructor(crumbs = []) {
    super();
    this.crumbs = crumbs;
  }

  toJson() {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: this.crumbs.map((crumb, idx) => ({
        "@type": "ListItem",
        position: idx + 1,
        name: crumb.name,
        item: crumb.url.startsWith("http") ? crumb.url : SEOData.siteUrl + crumb.url,
      })),
    };
  }
}
